"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeWorkflows_de_de = void 0;
function backofficeWorkflows_de_de() {
    return {
        "backoffice.workflows.widget.execute.title": "Workflow gestartet",
        "backoffice.workflows.widget.execute.message": "Möchten Sie nun zu Ihrer Aufgaben-Warteschlange gehen, um den Fortschritt des ausgeführten Workflows einzusehen?",
        "backoffice.workflows.widget.execute.buttons.gototaskbtn": "Gehe zu \"Aufgaben\"",
        "backoffice.workflows.widget.execute.buttons.close": "Schliessen",
        "backoffice.workflows.title": "Workflows",
        "backoffice.workflows.all": "Alle Workflows",
        "backoffice.workflows.dashboard.title": "Dashboard",
        "backoffice.workflows.list.title": "Liste aller Workflows",
        "backoffice.workflows.list.tabheader": "Workflows",
        "backoffice.workflows.tasks.title": "Liste aller Aufgaben",
        "backoffice.workflows.tasks.tabheader": "Aufgaben",
        "backoffice.workflows.executions.manualexecute": "Manuell ausführen",
        "backoffice.workflows.executions.templates": "Vorlagen",
        "backoffice.workflows.executions.title": "Workflow Ausführungen",
        "backoffice.workflows.executions.tabheader": "Ausführungen",
        "backoffice.workflows.trigger.title": "Manuell ausführen",
        "backoffice.workflows.trigger.message": "Möchten Sie diesen Workflow wirklich manuell ausführen?",
        "backoffice.workflows.create.title": "Workflow erstellen",
        "backoffice.workflows.create.subtitle": "Welches Label wollen sie ihrem Workflow zuweisen?",
        "backoffice.workflows.detail.tabheader": "Details",
        "backoffice.workflows.detail.active.no": "Nicht Aktiv",
        "backoffice.workflows.detail.active.always": "Aktiv",
        "backoffice.workflows.detail.active.range": "Definierter Zeitraum",
        "backoffice.workflows.detail.activate.title": "Workflow aktivieren",
        "backoffice.workflows.detail.activate.message": "Möchten Sie diesen Workflow wirklich aktivieren?",
        "backoffice.workflows.detail.deactivate.title": "Workflow deaktivieren",
        "backoffice.workflows.detail.deactivate.message": "Möchten Sie diesen Workflow wirklich deaktivieren?",
        "backoffice.workflows.detail.delete.title": "Workflow löschen",
        "backoffice.workflows.detail.delete.message": "Wollen Sie diesen Workflow wirklich löschen?",
        "backoffice.workflows.detail.triggers.description": "Sie können Ihre Workflows entweder manuell ausführen oder automatisiert starten, beispielsweise mit zeitgesteuerten Ereignissen. Eine Event gesteuerte Ausführung ist ebenfalls möglich. Hierfür geben Sie in der Liste unten einfach die Events an, bei denen Ihr Workflow ausgeführt werden soll.",
        "backoffice.workflows.detail.triggers.cronjob": "Zeigesteuert",
        "backoffice.workflows.detail.triggers.event": "Ereignis",
        "backoffice.workflows.detail.triggers.dialogtitle": "Ereignisauswahl",
        "backoffice.workflows.editor.deleteblock.title": "Block löschen",
        "backoffice.workflows.editor.deleteblock.message": "Wollen Sie diesen Workflow Block wirklich löschen?",
        "backoffice.workflows.editor.tabheader": "Editor",
        "backoffice.workflows.editor.dialog.title": "Workflowblock hinzufügen",
        "backoffice.workflows.editor.dialog.configinfo": "Konfigurieren Sie den ausgewählten Workflow Block",
        "backoffice.workflows.editor.dialog.socketinfo": "Erstellen Sie eine Verbindung zum neuen Block via Ziel-Socket.",
        "backoffice.workflows.editor.dialog.multisocket": "Für diesen Block gibt es mehr als einen möglichen Socket. Wählen Sie einen Socket für die Verbindung aus.",
        "backoffice.workflows.editor.dialog.sourcesocket": "Der neue Workflow Block muss mit einem der folgenden Socketausgänge verbunden werden.",
        "backoffice.workflows.editor.dialog.connect": "Verbinden",
        "backoffice.workflows.editor.config.title": "Block konfigurieren",
        "backoffice.workflows.editor.config.noschema": "Kein Schema gefunden! Block kann nicht konfiguriert werden.",
        "backoffice.workflows.blocks.globalstore.title": "Globaler Speicher",
        "backoffice.workflows.blocks.globalstore.description": "Speichert alle eingehenden Daten im globalen Speicher",
        "backoffice.workflows.blocks.propertymapper.title": "Daten Konverter",
        "backoffice.workflows.blocks.propertymapper.description": "Konvertiert Daten in das gewünschte Format"
    };
}
exports.backofficeWorkflows_de_de = backofficeWorkflows_de_de;
